import { CURRENT_USER_QUERY } from './useCurrentUser';

// refetch these queries after a currentUser have been updated
export const queriesToRefetchAfterCurrentUserMutation = [
  { query: CURRENT_USER_QUERY }
];
